"use client";

import React from "react";
import { useState, useEffect } from "react";
import ImageContent from "@/components/commons/ImageContent/ImageContent";
import { getArticleByCategory } from "@/actions/fetchQueryData";
import LoadMore from "@/components/LoadMore/LoadMore";
import { message, Spin } from "antd";
import "@ant-design/v5-patch-for-react-19";

type Props = {
  category: string;
  articleCount: number;
};

function LatestNews({ category, articleCount }: Props) {

  const [page, setPage] = useState(1);
  const [articles, setArticles] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!category || !page) return;

    const fetchArticles = async () => {
      setLoading(true);
      try {
        const data = await getArticleByCategory(category, page, 4);        

        setArticles((prev) => [...prev, ...(data?.articles || [])]);
      } catch {
        message.error("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, [page, category]);

  const onLoadMoreClick = () => {
    setPage(page + 1);
  };  

  return (
    <>
      <ImageContent title="More Articles" data={articles} numItemsToShow={articles.length} />

      {articles.length < articleCount && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          {loading ? <Spin size="large" /> : (
            <LoadMore onClick={onLoadMoreClick} title="Load More" />
          )}
        </div>
      )}
    </>
  );
}

export default React.memo(LatestNews);